const initialLocaleString = 'en-US';

export type LocaleType = string;
export const initialLocale: LocaleType = initialLocaleString;
